module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }